import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SideMenu from '../SideMenu';
import LoginModalLoginForm from './LoginModal.LoginForm';
import { showLogin } from '../../Actions/Login.action';
import Notification from '../Notification';
import LoginModalForgotPasswordForm from './LoginModal.ForgotPasswordForm';
import { getUrlQueryParameter } from '../../Services/utils';

const LOGIN_FORM = 'LOGIN_FORM';
const REGISTER_FORM = 'REGISTER_FORM';
const FORGOT_PASSWORD_FORM = 'FORGOT_PASSWORD_FORM';

const LoginModal = () => {
  const dispatch = useDispatch();
  const {
    open,
    registerUserLink,
    loginOverlayText,
    lostPasswordOverlayText,
  } = useSelector((state) => state.login);
  const [email, setEmail] = useState('');
  const [error, setError] = useState();
  const [currentForm, setCurrentForm] = useState(LOGIN_FORM);
  const [disableClosing, setDisableClosing] = useState(false);

  const onClosed = () => {
    dispatch(showLogin(false));
    setCurrentForm(LOGIN_FORM);
  };

  useEffect(() => {
    var loginRedirectUrl = getUrlQueryParameter('loginRedirectUrl');
    if (loginRedirectUrl) {
      setTimeout(() => dispatch(showLogin(true)), 300);
    }
  }, []);

  return (
    <SideMenu
      id="login-menu"
      open={open}
      onClosed={onClosed}
      disableClosing={disableClosing}
    >
      <div className="login-modal">
        {error && <Notification type="error" text={error} />}
        {currentForm == LOGIN_FORM && (
          <LoginModalLoginForm
            onError={setError}
            onForgotPasswordClick={() => setCurrentForm(FORGOT_PASSWORD_FORM)}
            email={email}
            registerUserLink={registerUserLink}
            loginOverlayText={loginOverlayText}
            onEmailChanged={setEmail}
            setDisableClosing={setDisableClosing}
          />
        )}
        {currentForm == FORGOT_PASSWORD_FORM && (
          <LoginModalForgotPasswordForm
            onBackClick={() => setCurrentForm(LOGIN_FORM)}
            lostPasswordOverlayText={lostPasswordOverlayText}
            prefilledEmail={email}
            onError={setError}
          />
        )}
      </div>
    </SideMenu>
  );
};

export default LoginModal;
